import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import cfg from "./publicRoutes.json";

const ROUTES = Object.fromEntries(cfg.routes.map((r) => [r.path, r]));
const HOME = ROUTES["/"];

const setTag = (sel, make) => {
  let el = document.head.querySelector(sel);
  if (!el) { el = make(); document.head.appendChild(el); }
  return el;
};
const meta = (attr, key, content) => {
  const el = setTag(`meta[${attr}="${key}"]`, () => { const m = document.createElement("meta"); m.setAttribute(attr, key); return m; });
  el.content = content;
};

// Per-route title/description/canonical; private or duplicate pages are marked noindex.
export function SeoHead() {
  const { pathname } = useLocation();
  useEffect(() => {
    const p = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
    const route = ROUTES[p];
    const url = cfg.siteUrl + (route ? (p === "/" ? "/" : p) : "/");
    document.title = route ? route.title : cfg.privateTitle;
    const desc = (route || HOME).description;
    const link = setTag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }));
    link.href = url;
    meta("name", "robots", route ? "index, follow" : "noindex, nofollow");
    meta("name", "description", desc);
    if (route && p !== "/") {
      meta("property", "og:title", route.title);
      meta("property", "og:description", desc);
      meta("property", "og:url", url);
    } else if (p === "/") {
      meta("property", "og:title", "Karmivo | Labour Booking & Workforce Platform");
      meta("property", "og:description", "A managed labour workforce platform in Jaipur.");
      meta("property", "og:url", url);
    }
  }, [pathname]);
  return null;
}
